import FaqRoute from "./faq.js";

// Rules is effectively a faq alias
export default class RulesRoute extends FaqRoute {
  pageId = "rules";
}
